<template>
  <div class="d-flex flex-column" style="width: 100%" @click="openMenu">
    <BaseTextField
      :label="label"
      :required="required"
      hide-details
      v-model="color"
      @change="updateColor"
      :clearable="clearable"
      @click:clear="cleanColor"
      :rules="[rules.length > 0 ? rules[0] : true]"
    >
      <template v-slot:append>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          offset-y
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on }">
            <div :style="swatchStyle" v-on="on" />
          </template>
          <v-card>
            <v-card-text>
              <v-color-picker @blur="updateColor" mode="hexa" v-model="color" />
            </v-card-text>
          </v-card>
        </v-menu>
      </template>
    </BaseTextField>
  </div>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
import mixins from "@/mixins";

export default {
  name: "ColorPicker",
  mixins: [mixins],
  components: {
    BaseTextField,
  },
  data() {
    return {
      menu: false,
      color: "",
    };
  },
  methods: {
    updateColor() {
      let hexColor =
        typeof this.color === "object" ? this.color?.hex : this.color;
      if (hexColor && hexColor.length === 9) {
        hexColor = hexColor.slice(0, 7);
      }
      this.$emit("updateColor", hexColor);
    },
    cleanColor() {
      this.color = undefined;
      this.$emit("updateColor", this.color);
    },
    openMenu() {
      this.menu = true;
    },
  },
  beforeMount() {
    this.color = this.edit || "";
  },
  computed: {
    swatchStyle() {
      const { menu } = this;
      return {
        backgroundColor: this.color,
        cursor: "pointer",
        height: "24px",
        width: "24px",
        borderRadius: menu ? "20px" : "4px",
        border: "1px solid #ccc",
        transition: "border-radius 200ms ease-in-out",
      };
    },
  },
  watch: {
    edit() {
      this.color = this.edit || "";
    },
  },
  props: {
    edit: {
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    inputRules: {
      type: Object,
      default: () => {},
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
